import api from "./ApiCentralAjuda";

const ticketService = {
    store: (dados) => {
        let uri = "/ticket";
        return api["post"].call(api, uri, dados, {
            "Content-Type": "multipart/form-data",
        });
    },
};

export default ticketService;
